import Header from "../components/Header";
import Title from "../components/Title";
import { phone, email, location } from "../assets/icons/index";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";

interface ContactUsProps {}

const ContactUs = ({}: ContactUsProps) => {
  const { i18n, t } = useTranslation();
  return (
    <>
      <Header />

      <main
        className={`w-full ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/* hero section  *****************************/}
        <Title title={t("Contact Us")} subtitle={t("Contact Us")} />{" "}
        {/* Contact details   *************************/}
        <section className="px-[20px] lg:px-[140px] flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-around">
          <div className="flex items-center gap-4">
            <img src={phone} alt="" />
            <div>
              <p className="text-[#263A4B] text-[18px]">{t("Phone")}</p>
              <p className="text-[15px] font-[700]">+971 6 005 7898</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <img src={email} alt="" />
            <div>
              <p className="text-[#263A4B] text-[18px]">{t("Email")}</p>
              <p className="text-[15px] font-[700]">info@onxycom.ae</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <img src={location} alt="" />
            <div>
              <p className="text-[#263A4B] text-[18px]">{t("Address")}</p>
              <p className="text-[15px] font-[700]">
                {t("3 Al-Sheikh Zayed street, Dubai, UAE")}
              </p>
            </div>
          </div>
        </section>
        {/* contact us form  **************************/}
        <section className="my-[100px] px-[20px] lg:px-[280px] flex items-center justify-center">
          <div className="p-[20px] w-full  border border-[#D3D3D3] rounded-[20px] flex flex-col gap-4">
            <p className="text-[20px] font-[700] ">
              {t("Get in Touch with Us")}
            </p>

            <form className="flex flex-col gap-8">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 ">
                <input
                  type="text"
                  placeholder={t("Full Name")}
                  className="w-full pl-[10px] border-b-2 pb-[10px] focus:outline-none"
                />
                <input
                  type="email"
                  placeholder={t("Email")}
                  className="w-full pl-[10px] border-b-2 pb-[10px] focus:outline-none"
                />
                <input
                  type="text"
                  placeholder={t("Phone")}
                  className="w-full pl-[10px] border-b-2 pb-[10px] focus:outline-none"
                />
              </div>

              <textarea
                placeholder={t("Message")}
                className="w-full border min-h-[111px] rounded-[20px] p-[20px]"
              ></textarea>

              <div className="w-full flex justify-center lg:justify-end">
                <button className="w-[200px] h-[40px] rounded-[12px] bg-[#E4002F] text-white lg:text-[14px]">
                  {t("Send Message")}
                </button>
              </div>
            </form>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default ContactUs;
